import DeltaCounts from "components/DeltaCounts";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Box from "ds/components/Box";
import Tab from "ds/components/Tab";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import { RunContext } from "components/Run/Context";
import { ansibleRunHasTasks } from "components/Run/helpers";

const RunHeaderAnsibleChangesNav = () => {
  const { run } = useTypedContext(RunContext);
  const hasTasks = !!run.delta && ansibleRunHasTasks(run.delta);
  const hasPluginOutputs = run.pluginLogs && run.pluginLogs.length > 0;

  return (
    <ViewHeaderNavigation>
      <Tab end id="History" label="History" to=".." />

      {!!run.delta && !hasTasks && (
        <Typography variant="p-t6" tag="div" margin="0 medium">
          No tasks
        </Typography>
      )}

      {hasTasks && (
        <Tab
          id="Tasks"
          to="../tasks"
          label={
            <Box gap="medium" align="center">
              Tasks
            </Box>
          }
          suffixComponent={
            <DeltaCounts isAnsible delta={run?.delta} skipEmpty variant="flexible" size="small" />
          }
        />
      )}
      {hasPluginOutputs && <Tab label="Plugin Outputs" to="../plugin-outputs" />}
    </ViewHeaderNavigation>
  );
};

export default RunHeaderAnsibleChangesNav;
